import script from "./LocationAdminTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationAdminTable.vue?vue&type=script&setup=true&lang=js"

import "./LocationAdminTable.vue?vue&type=style&index=0&id=9a02adc4&lang=css"

const __exports__ = script;

export default __exports__